export const FILTER_CLIENTS = "CLIENTS/FILTER_CLIENTS";
export const CLEAR_FILTER = "CLIENTS/CLEAR_FILTER";
export const WRAP_CLIENTS = "CLIENTS/WRAP_CLIENTS";
export const GET_INFO = "CLIENTS/GET_INFO";
export const SET_LOADING = "CLIENTS/SET_LOADING";
export const SET_SKELETON = "CLIENTS/SET_SKELETON";
export const PREFILTER_CLIENTS = "CLIENTS/PREFILTER_CLIENTS";
